<template>
  <div class="container flow-canvas">

    <DndPanel @drag-start="onDragStart" style="position:fixed;left:80px;top:140px;z-index:100" />
    <ActionPanel @on-click="handleActionEvent" style="position:fixed;left:calc(50% - 200px);top:60px;z-index:100" />
    <PropertyPanel
      :element="selected || flow"
      :prop="elementProps"
      :env="propertyEnv"
      @on-event="handleEvent"
      @on-change-prop="handleChangeProperty"
      style="position:fixed;right:80px;top:140px;z-index:100" />
    <FormPanel
      v-model="forms"
      style="position:fixed;bottom:50px;;z-index:100"
      :option="{flowId:flow.id}"
    />

    <div class="l-canvas" ref="canvas"> </div>

    <BaseLoadingModal :value="loading" title="正在处理" />

    <Modal
      v-model="showInstance"
      fullscreen
      footer-hide
      class-name="flow-test-modal"
      @on-visible-change="onTestVisible"
    >
      <FlowInstance
        v-if="showInstance"
        :flow="flowDef"
        :version="testGraph"
        :graph="testGraph"
        test
        fullscreen
      />
    </Modal>

  </div>
</template>

<script>
import LogicFlow from '@logicflow/core';
import {Snapshot, SelectionSelect, MiniMap, Menu} from '@logicflow/extension';
import DndPanel from './components/DndPanel.vue';
import ActionPanel from './components/ActionPanel.vue';
import FormPanel from './components/FormPanel.vue';
import mixinResponsable from '@/mixins/responsable';
import '@logicflow/core/dist/index.css';
import '@logicflow/extension/dist/index.css';
import ApprovalNode from './components/nodes/approval.js';
import StartNode from './components/nodes/start.js';
import EndNode from './components/nodes/finish.js';
import EventNode from './components/nodes/event.js';
import PropertyPanel from './components/PropertyPanel';
import mixinState from '@/mixins/page_state';
import CarbonNode from './components/nodes/carbon';
import FlowInstance from '../instance.vue';
import SubmitEdge from './components/edges/submit';
import {cloneDeep} from 'lodash';
import UTIL from '@/utils';
import {NODE_OPTION_RECOVER_KEYS} from '@/components/flow/flow-version';
LogicFlow.use(Snapshot);
LogicFlow.use(SelectionSelect);
LogicFlow.use(MiniMap);
LogicFlow.use(Menu);
export default {
  data() {
    return {
      lf: null,
      lf_data: null,
      nodes: [],
      loading: false,
      showInstance: false,
      testGraph: null,
      selected: null,
      flowData: {},
      showFlow: {},
      forms: [],
    };
  },
  props: {
    'flow-def': {
      type: Object,
      default: ()=>({}),
    },
    'flow': {
      type: Object,
      default: ()=>({}),
    },
  },
  mixins: [mixinResponsable, mixinState],
  components: {DndPanel, ActionPanel, PropertyPanel, FormPanel, FlowInstance},
  computed: {
    flow_id() {
      return this.$route.params.id;
    },
    startFormId() {
      let nodes = [];
      if (this.lf) {
        try {
          nodes = (this.lf.getGraphData() || {}).nodes || [];
        } catch (e) {
          nodes = [];
        }
      }
      if (!nodes.length) {
        nodes = (this.showFlow && this.showFlow.nodes) ||
          (this.flow && this.flow.nodes) ||
          [];
      }
      const start = nodes.find((n)=>n.type === 'start_node');
      return start?.properties?.view_id || null;
    },
    startNode() {
      let nodes = [];
      if (this.lf) {
        try {
          nodes = (this.lf.getGraphData() || {}).nodes || [];
        } catch (e) {
          nodes = [];
        }
      }
      if (!nodes.length) {
        nodes = (this.showFlow && this.showFlow.nodes) ||
          (this.flow && this.flow.nodes) ||
          [];
      }
      return nodes.find((n)=>n.type === 'start_node') || null;
    },
    startAcl() {
      const start = this.startNode;
      const raw = start && (start.properties || start.option) &&
        (start.properties || start.option).acl;
      return raw || {};
    },
    propertyEnv() {
      return {
        forms: this.forms,
        startFormId: this.startFormId,
        startAcl: this.startAcl,
      };
    },
    elementProps() {
      if (!this.selected) {
        return {
          tools: [],
          attrs: [{
            key: 'name',
            label: '名称',
            control: 'Text',
          }, {
            key: 'version',
            label: '版本号',
            control: 'Text',
          }, {
            key: 'description',
            label: '版本说明',
            control: 'Textarea',
          }, {
            key: 'nameRule',
            label: '实例命名',
            control: 'TplString',
            desc: '发起时按模板生成实例名称；仅可选开始节点「可编辑」字段（创建时能填写的字段），如：投标-{project_info.name}',
            option: {
              form_id: this.startFormId,
              acl: this.startAcl,
              editableOnly: true,
              placeholder: '如：投标-{project_info.name}',
            },
          }, {
            key: 'active',
            label: '设为默认',
            control: 'Check',
          }],
        };
      } else {
        const model= this.lf.getModelById(this.selected.id);
        let props = [];
        const attrs = [{
          key: 'type',
          label: '类型',
          disabled: true,
          control: 'Text',
          option: {
            labelMap: {
              start_node: '开始',
              approval_node: '审批',
              carbon_node: '抄送',
              finish_node: '结束',
              timer_node: '定时',
              repeat_node: '重复',
              event_node: '事件',
              'approval-edge': '连线',
            },
          },
        }, {
          key: 'x',
          label: 'x',
          disabled: true,
          control: 'Text',
        }, {
          key: 'y',
          label: 'y',
          disabled: true,
          control: 'Text',
        }];
        let tools = [{
          name: '删除',
          icon: 'md-trash',
          title: '删除(Backspace)',
          key: 'delete',
        }];
        if (model.getTools) {
          tools = tools.concat(...(model.getTools() || []));
        }
        if (model.getProps) {
          props = model.getProps() || [];
        }

        if (model.BaseType == 'edge') {
          props = props.concat([{
            key: 'type',
            label: '类型',
            control: 'Select',
            option: {
              options: [{value: 'submit', label: '提交'}, {value: 'reject', label: '退回'}],
            },
            group: '审批',
          }, {
            key: 'condition',
            label: '条件',
            control: 'Condition',
            group: '审批',
          }]);
        }
        console.log(model, props);
        if (model.BaseType == 'node') {
          const isCarbon = this.selected.type === 'carbon_node' ||
            model.type === 'carbon_node';
          props = props.concat([{
            key: 'view_id',
            label: '视图',
            control: 'Select',
            group: '视图',
            desc: '本节点展示与填写所使用的表单视图',
            option: {
              options: this.forms.map((v)=>({label: v.name, value: v.id})),
            },
          }, {
            key: 'acl',
            label: '表单权限配置',
            control: 'PermissionSelect',
            group: '视图',
            desc: isCarbon ?
              '抄送节点仅配置字段可见性（不可编辑、无默认值绑定）' :
              '配置本节点字段的可见/可编辑，以及执行后写入表单的默认值绑定',
            editable: this.selected.properties.view_id,
            option: {
              mode: 'form',
              form_id: this.selected.properties.view_id,
              visibilityOnly: isCarbon,
            },
          }]);
        }

        // 克隆字段选择器：可选前置节点表单 + 默认（开始）表单
        // 有克隆对象时展示「分类默认人」，隐藏普通默认人；反之亦然
        const hasClonedBy = (() => {
          const cb = this.selected && this.selected.properties && this.selected.properties.clonedBy;
          if (!cb) return false;
          if (typeof cb === 'string') return !!cb;
          return !!(cb.key);
        })();
        props = props.map((p)=>{
          if (p.key === 'clonedBy' && p.control === 'FieldSelect') {
            const cloneForms = this.getCloneableForms(this.selected);
            return {
              ...p,
              option: {
                ...(p.option || {}),
                forms: cloneForms,
                defaultFormId: this.startFormId,
              },
            };
          }
          if (p.key === 'default-users' && hasClonedBy) {
            return {...p, hidden: true};
          }
          if (p.key === 'clonedDefaultUsers' && !hasClonedBy) {
            return {...p, hidden: true};
          }
          if (p.key === 'parallelVisible' && !hasClonedBy) {
            return {...p, hidden: true};
          }
          if (p.key === 'clonedKey') {
            return {...p, hidden: true};
          }
          return p;
        }).filter((p) => !p.hidden);

        return {attrs, tools, props};
      }
    },
  },
  mounted() {
    this.$nextTick(()=>{
      this.Init();
    });
  },
  methods: {
    getGraphNodes() {
      if (this.lf) {
        try {
          return (this.lf.getGraphData() || {}).nodes || [];
        } catch (e) {
          // ignore
        }
      }
      return (this.showFlow && this.showFlow.nodes) ||
        (this.flow && this.flow.nodes) ||
        [];
    },
    getGraphEdges() {
      if (this.lf) {
        try {
          return (this.lf.getGraphData() || {}).edges || [];
        } catch (e) {
          // ignore
        }
      }
      return (this.showFlow && this.showFlow.edges) ||
        (this.flow && this.flow.edges) ||
        [];
    },
    getCloneableForms(node) {
      if (!node) {
        return [];
      }
      const formMap = {};
      const allForms = this.forms || [];
      const byId = (id)=>{
        if (!id) {
          return null;
        }
        return allForms.find((f)=>f.id === id) || null;
      };

      // 默认表单：开始节点视图
      if (this.startFormId) {
        const def = byId(this.startFormId);
        if (def) {
          formMap[def.id] = {...def, isDefault: true};
        } else {
          formMap[this.startFormId] = {
            id: this.startFormId,
            name: '默认表单',
            isDefault: true,
          };
        }
      }

      // 前置节点已绑定的表单
      const edges = this.getGraphEdges();
      const nodes = this.getGraphNodes();
      const incoming = edges.filter((e)=>e.targetNodeId === node.id);
      incoming.forEach((e)=>{
        const src = nodes.find((n)=>n.id === e.sourceNodeId);
        const viewId = src?.properties?.view_id;
        if (!viewId) {
          return;
        }
        if (formMap[viewId]) {
          return;
        }
        const form = byId(viewId);
        formMap[viewId] = form ?
          {...form, isDefault: false} :
          {id: viewId, name: src?.properties?.name || src?.text?.value || viewId, isDefault: false};
      });

      const list = Object.values(formMap);
      list.sort((a, b)=>{
        if (a.isDefault === b.isDefault) {
          return 0;
        }
        return a.isDefault ? -1 : 1;
      });
      return list;
    },
    __beforeSavePageState() {
      if (this.lf && this.flow_id == 'create') {
        try {
          localStorage.setItem('lf_content', JSON.stringify(this.getGraphData()));
        } catch (e) {
          console.warn('save page state failed', e);
        }
      }
    },
    __afterRestorePageState() {
      const data = localStorage.getItem('lf_content');
      if (data && this.flow_id == 'create') {
        this.lf_data = JSON.parse(data);
        localStorage.removeItem('lf_content');
      }
    },
    Init() {
      if (this.lf) {
        delete this.lf;
      }

      const container = this.$refs.canvas;
      if (!container) {
        return;
      }
      this.$nextTick(() => {
        this.lf = new LogicFlow({
          container,
          width: container.clientWidth,
          height: container.clientHeight,
          background: {color: '#F0F0F0'},
          grid: {type: 'dot', size: 20},
          textEdit: true,
          isSilentMode: false,
          edgeType: 'approval-edge',
          stopScrollGraph: true,
          animation: true,
          snapline: true,
          stopMoveGraph: false,
          adjustEdgeStartAndEnd: true,
          history: true,
          keyboard: {
            enabled: true,
          },
          outline: true,
          style: {rect: {radius: 6}},

        });

        this.lf.register(StartNode);
        this.lf.register(ApprovalNode);
        this.lf.register(EndNode);
        this.lf.register(EventNode);
        this.lf.register(CarbonNode);

        this.lf.register(SubmitEdge);

        this.Render();
        this.lf.translateCenter();
        this.lf.on('blank:click', (e)=>{
          this.selected = null;
        });
        this.lf.on('history:change', ()=>{
          this.UpdateLocal();
          if (this.selected) {
            this.selected = this.lf.getDataById(this.selected.id);
          }
        });
        this.lf.extension.miniMap.show();
        this.lf.on('element:click', (event) => {
          const {data} = event;
          console.log(data);
          this.selected = data;
          this.normalizeSelectedOpinionMode(data);

          // 菜单
          this.lf.addMenuConfig({
            nodeMenu: [],
            edgeMenu: [],
          });
        });

        this.$emit('on-refresh');
      });
    },
    Render(data) {
      if (data) {
        this.lf.render(data);
      } else if (this.lf_data) {
        this.lf.render(this.lf_data);
        this.lf_data = null;
      } else {
        this.lf.render();
      }
    },
    handleChangeProperty({key, value}) {
      if (this.selected == null || !this.lf) {
        return;
      }
      const elementId = this.selected.id;
      const elementModel = this.lf.getModelById(elementId);
      if (!elementModel) {
        return;
      }
      console.log('change-prop:', elementModel, key, value);
      const plainValue = this.toPlainData(value);

      // 面板 properties 与模型 properties 合并，避免改一项时冲掉 acl / clonedBy
      const modelProps = (typeof elementModel.getProperties === 'function' ?
        elementModel.getProperties() :
        elementModel.properties) || {};
      const panelProps = (this.selected && this.selected.properties) || {};
      const merged = {
        ...this.safePropsClone(modelProps),
        ...this.safePropsClone(panelProps),
        [key]: plainValue,
      };
      if (key === 'opinionMode') {
        delete merged.enableOpinion;
      }

      if (typeof elementModel.setProperties === 'function') {
        elementModel.setProperties(merged);
      } else {
        elementModel.properties = merged;
      }
      this.selected.properties = {
        ...(this.selected.properties || {}),
        ...merged,
      };

      elementModel.updateAttributes({});
      this.UpdateLocal();
    },
    /** 浅层安全克隆节点 properties，保留 acl/clonedBy 等可序列化结构 */
    safePropsClone(props) {
      if (!props || typeof props !== 'object') {
        return {};
      }
      const plain = this.toPlainData(props);
      if (plain && typeof plain === 'object' && !Array.isArray(plain)) {
        const out = {...plain};
        // JSON 若丢了关键业务字段，从原对象补回
        ['acl', 'clonedBy', 'clonedDefaultUsers', 'view_id', 'approval-region',
          'default-users', 'executor-region'].forEach((k) => {
          if (out[k] == null && props[k] != null) {
            const recovered = this.toPlainData(props[k]);
            out[k] = recovered != null ? recovered : (
              Array.isArray(props[k]) ? props[k].slice() : {...props[k]}
            );
          }
        });
        return out;
      }
      const out = {};
      Object.keys(props).forEach((k) => {
        if (k.startsWith('__') || k.startsWith('$')) return;
        const v = props[k];
        if (typeof v === 'function' || typeof v === 'undefined') return;
        if (v && typeof v === 'object') {
          const nested = this.toPlainData(v);
          out[k] = nested != null ? nested : (
            Array.isArray(v) ? v.slice() : {...v}
          );
        } else {
          out[k] = v;
        }
      });
      return out;
    },
    /** 旧 enableOpinion /「无」→ opinionMode（必须/可选/表单），只补字段不整包替换 */
    normalizeSelectedOpinionMode(data) {
      if (!data || data.type !== 'approval_node' || !data.properties) return;
      const p = data.properties;
      if (p.opinionMode === '无') {
        const elementModel = this.lf && this.lf.getModelById(data.id);
        if (elementModel && typeof elementModel.setProperties === 'function') {
          elementModel.setProperties({opinionMode: '表单'});
        } else if (elementModel && elementModel.properties) {
          this.$set(elementModel.properties, 'opinionMode', '表单');
        }
        this.$set(data.properties, 'opinionMode', '表单');
        return;
      }
      if (p.opinionMode === '必须' || p.opinionMode === '可选' || p.opinionMode === '表单') {
        return;
      }
      let mode = '可选';
      if (p.enableOpinion === false) mode = '表单';
      else if (p.enableOpinion === true) mode = '可选';

      const elementModel = this.lf && this.lf.getModelById(data.id);
      if (elementModel && typeof elementModel.setProperties === 'function') {
        elementModel.setProperties({opinionMode: mode});
        if (elementModel.properties) {
          delete elementModel.properties.enableOpinion;
        }
      } else if (elementModel && elementModel.properties) {
        this.$set(elementModel.properties, 'opinionMode', mode);
        this.$delete(elementModel.properties, 'enableOpinion');
      }
      this.$set(data.properties, 'opinionMode', mode);
      this.$delete(data.properties, 'enableOpinion');
    },
    /** 切断 Vue 响应式与循环引用，保证可 JSON 序列化 */
    toPlainData(value) {
      if (value == null || typeof value !== 'object') {
        return value;
      }
      try {
        return JSON.parse(JSON.stringify(value));
      } catch (e) {
        if (Array.isArray(value)) {
          return value.map((item) => this.toPlainData(item));
        }
        const out = {};
        Object.keys(value).forEach((k) => {
          if (k.startsWith('__') || k.startsWith('$')) {
            return;
          }
          const v = value[k];
          const t = typeof v;
          if (t === 'function' || t === 'undefined') {
            return;
          }
          if (v && t === 'object') {
            if (v._isVue || v.$el || (v.constructor && /Vue|Watcher|EffectScope|VNode/.test(v.constructor.name))) {
              return;
            }
            out[k] = this.toPlainData(v);
          } else {
            out[k] = v;
          }
        });
        return out;
      }
    },
    handleEvent(key) {
      if (key == 'delete') {
        if (!this.selected) {
          return;
        }
        if (Array.isArray(this.selected)) {

        } else {
          this.lf.deleteElement(this.selected.id);
        }

        this.selected = null;
      }
    },
    onResize(w, h) {
      if (this.lf) {
        this.lf_data = this.lf.getGraphData();
        this.Init();
      }
    },
    onDragStart(type) {
      this.lf.dnd.startDrag({type});
    },
    setLoading(enable) {
      this.loading = enable;
    },
    recoverNodeProperties(plainProps, rawProps) {
      const out = (plainProps && typeof plainProps === 'object' && !Array.isArray(plainProps)) ?
        {...plainProps} :
        {};
      const raw = rawProps && typeof rawProps === 'object' ? rawProps : {};
      NODE_OPTION_RECOVER_KEYS.forEach((key) => {
        if (out[key] != null) return;
        if (raw[key] == null) return;
        const recovered = this.toPlainData(raw[key]);
        out[key] = recovered != null ? recovered : (
          Array.isArray(raw[key]) ? raw[key].slice() : (
            typeof raw[key] === 'object' ? {...raw[key]} : raw[key]
          )
        );
      });
      return out;
    },
    getNodeModelProperties(nodeId) {
      if (!this.lf || !nodeId) return {};
      const model = this.lf.getModelById(nodeId);
      if (!model) return {};
      if (typeof model.getProperties === 'function') {
        return model.getProperties() || {};
      }
      return model.properties || {};
    },
    getGraphData() {
      if (!this.lf) {
        return {
          ...this.flow,
          nodes: this.flow?.nodes || [],
          edges: this.flow?.edges || [],
        };
      }
      const graph = this.lf.getGraphData() || {};
      const nodes = (graph.nodes || []).map((n) => {
        const merged = this.safePropsClone({
          ...this.getNodeModelProperties(n.id),
          ...(n.properties || {}),
        });
        return {...n, properties: merged};
      });
      const payload = {...this.flow, ...graph, nodes};
      // 导出前净化，避免 properties 中的循环引用导致 JSON 失败
      const plain = this.toPlainData(payload) || payload;
      (plain.nodes || []).forEach((n, i) => {
        const src = nodes[i];
        if (!n || !src) return;
        n.properties = this.recoverNodeProperties(n.properties, src.properties);
      });
      return plain;
    },
    Save() {
      const res = this.getGraphData();
      this.$emit('on-submit', res);
    },
    UpdateLocal() {
      if (!this.lf) {
        return;
      }
      const res = this.lf.getGraphData();
      const nodes = (res.nodes || []).map((n)=>({
        ...n,
        properties: this.toPlainData(n.properties || {}) || {},
      }));
      this.showFlow = {...this.flow, ...res, nodes};
    },
    CreateTest() {
      // 使用当前画布最新数据做本地模拟
      this.testGraph = this.getGraphData();
      this.showInstance = true;
    },
    onTestVisible(visible) {
      if (!visible) {
        this.testGraph = null;
      }
    },
    handleActionEvent(type) {
      const actionMap = {
        'download': ()=>{
          this.lf.getSnapshot('flow');
        },
        'selection': ()=>{
          this.lf.openSelectionSelect();
        },
        'arrow': ()=>{
          this.lf.closeSelectionSelect();
        },
        'undo': ()=>{
          this.lf.undo();
        },
        'redo': ()=>{
          this.lf.redo();
        },
        'zoom-in': ()=>{
          this.lf.zoom(true);
        },
        'zoom-out': ()=>{
          this.lf.zoom(false);
        },
        'expand': ()=>{
          this.lf.fitView(300, 300);
        },
        'reset': ()=>{
          this.$emit('on-refresh');
        },
        'save': this.Save,
        'test': this.CreateTest,
      };
      const func = actionMap[type];
      if (func) {
        func();
      }
    },
  },
};
</script>

<style lang="less">
.flow-canvas {
  background: rgb(240, 249, 255);
  position: relative;
}

.l-canvas {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: #ffe;
  overflow: hidden;
}


.lf-tool-overlay{
  .lf-menu{
    .lf-menu-item{
      color:#333;
    }
  }
}

.lf-text-input{
  color:#333;
}

.flow-test-modal {
  .ivu-modal-header {
    height: 0;
    padding: 0;
    border: none;
    overflow: visible;
  }
  .ivu-modal-header-inner {
    display: none;
  }
  .ivu-modal-close {
    top: 8px;
    right: 10px;
    z-index: 30;
  }
  .ivu-modal-body {
    padding: 0;
    height: 100vh;
    max-height: 100vh;
    overflow: hidden;
  }
}

</style>
